import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ChatStatusAction } from './types';

function startChatBotApi() {
  const apiUrl = process.env.REACT_APP_INSERT_START_LOG!;
  let userId = localStorage.getItem('user_token');
  if (userId === null) {
    userId = '';
  }
  const params = new URLSearchParams();
  params.append('id', userId);
  return axios.post(apiUrl, params).then(response => response.data);
}
export function* startChatBot(action: any) {
  try {
    const keywords = yield call(startChatBotApi);
    yield put({
      type: ChatStatusAction.START_CHATBOT_LOG_SUCCESS,
      payload: {
        keywords
      }
    });
  } catch (e) {
    yield put({
      type: ChatStatusAction.START_CHATBOT_LOG_FAILURE,
      message: e.message
    });
  }
}

export const chatStatusSaga = [
  takeEvery(ChatStatusAction.START_CHATBOT_LOG_REQUEST, startChatBot)
];
// export function* chatStatusSaga() {
//   yield all([
//     yield takeEvery(ChatStatusAction.START_CHATBOT_LOG_REQUEST, startChatBot)
//   ]);
// }
